// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorProductRequests = (client) => ({
    /**
     * `POST /vendor/product-requests/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductRequestsIdApproveCreate
     * @source packages/modules/b2c-core/src/api/vendor/product-requests/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-requests/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/product-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/modules/b2c-core/src/api/vendor/product-requests/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/product-requests", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/product-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductRequestsList
     * @source packages/modules/b2c-core/src/api/vendor/product-requests/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/product-requests", { method: "GET", query, headers }),
    /**
     * `POST /vendor/product-requests/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductRequestsIdRejectCreate
     * @source packages/modules/b2c-core/src/api/vendor/product-requests/[id]/reject/route.ts
     */
    reject: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-requests/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/product-requests/incoming`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductRequestsIncomingRetrieve
     * @source packages/modules/b2c-core/src/api/vendor/product-requests/incoming/route.ts
     */
    retrieveIncoming: (query, headers) => client.fetch("/vendor/product-requests/incoming", { method: "GET", query, headers }),
    /**
     * `POST /vendor/product-requests/:id/revoke`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorProductRequestsIdRevokeCreate
     * @source packages/modules/b2c-core/src/api/vendor/product-requests/[id]/revoke/route.ts
     */
    revoke: (id, body, query, headers) => client.fetch(buildPath("/vendor/product-requests/:id/revoke", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=product-requests.js.map